import styled from "styled-components";

const BodyContainer = styled.div`
  padding: 10px 30px 30px 30px;
  background-color: transparent;
  border-radius: 0px 0px 4px 4px;
`;

export default BodyContainer;
